import "core-js/modules/es.array.map";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from "prop-types";
import React from "react";
import ProductCard from "web/react/components/product-card/product-card";
import Rail from "web/react/components/rail/rail";
import { ProductCardPropType } from "web/types/product-card";
import classnames from "classnames";
import styles from "./product-rail.css";

function ProductRail(_ref) {
  var className = _ref.className,
      hiddenProductsCount = _ref.hiddenProductsCount,
      label = _ref.label,
      products = _ref.products,
      title = _ref.title,
      viewMoreUrl = _ref.viewMoreUrl,
      railClassName = _ref.railClassName,
      features = _ref.features,
      type = _ref.type,
      id = _ref.id,
      imageSize = _ref.imageSize;
  var leftButtonStyle = "";
  var rightButtonStyle = "";

  if (type == "homepage") {
    leftButtonStyle = classnames(styles.scrollButton, styles.left);
    rightButtonStyle = classnames(styles.scrollButton, styles.right);
  }

  return React.createElement(Rail, {
    analyticsLabel: label,
    className: className,
    peekingCard: features.uj_peeking_card,
    railClassName: railClassName,
    seeAllLink: viewMoreUrl,
    title: title,
    titlePosition: "center",
    leftButtonStyle: leftButtonStyle,
    rightButtonStyle: rightButtonStyle,
    id: id
  }, products.map(function (product, index) {
    return React.createElement(ProductCard, {
      className: classnames(styles.productCard, _defineProperty({}, styles.largeProductCard, type == "homepage")),
      key: product.id,
      product: product,
      hideOnDesktop: index < hiddenProductsCount ? true : false,
      imageSize: imageSize,
      scrollParentId: id
    });
  }));
}

ProductRail.propTypes = {
  className: PropTypes.string,
  features: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.bool, PropTypes.string])),
  railClassName: PropTypes.string,
  hiddenProductsCount: PropTypes.number,
  label: PropTypes.string.isRequired,
  products: PropTypes.arrayOf(ProductCardPropType).isRequired,
  title: PropTypes.string.isRequired,
  viewMoreUrl: PropTypes.string,
  type: PropTypes.string,
  id: PropTypes.string,
  imageSize: PropTypes.string
};
export default ProductRail;